import { useQuery } from '@apollo/client'
import * as React from 'react'
import * as CommonStyles from '../common/CommonStyles'

import MaterialTable, { Icons } from 'material-table'
import { tableIcons } from 'components/common/MaterialIcons'

import { Insight, Partner } from 'graphql/types'
import adminInsights, { AdminInsightQueryType } from 'graphql/queries/adminInsights'
import InsightDetails from './details'
import { Box, CircularProgress, FormControl, InputLabel, MenuItem, Select, Switch } from '@material-ui/core'
import partners from 'graphql/queries/partners'

const Insights = () => {
  const alertStatusCached = localStorage.getItem('alertStatus')
  const [alertStatus, setAlertStatus] = React.useState(alertStatusCached ? alertStatusCached === 'true' : true)
  const setAlertStatusCache = (status: boolean) => {
    localStorage.setItem('alertStatus', status.toString())
    setAlertStatus(status)
  }

  const partnerIDCached = localStorage.getItem('partnerID')
  const [partnerID, setPartnerID] = React.useState(partnerIDCached ? partnerIDCached : 'racq')
  const setPartnerIDCache = (partnerID: string) => {
    localStorage.setItem('partnerID', partnerID)
    setPartnerID(partnerID)
  }

  const insightsDomainCached = localStorage.getItem('insightsDomain')
  const [domain, setDomain] = React.useState(insightsDomainCached ? insightsDomainCached : 'energy')
  const setDomainCache = (domain: string) => {
    localStorage.setItem('insightsDomain', domain)
    setDomain(domain)
  }

  const { loading: partnersLoading, error: err, data: partnerData } = useQuery(partners)
  const { loading, error, data, refetch } = useQuery<AdminInsightQueryType>(adminInsights, {
    fetchPolicy: 'no-cache',
    variables: { PartnerID: partnerID },
  })

  if (loading || partnersLoading)
    return (
      <div>
        <h1
          style={{ display: 'inline-block', verticalAlign: 'sub', marginLeft: '12px' }}
          className={CommonStyles.MainHeaderClass}
        >
          Energy Insight Issues
        </h1>
        <div
          style={{
            boxShadow:
              '0px 3px 1px -2px rgba(0,0,0,0.2),0px 2px 2px 0px rgba(0,0,0,0.14),0px 1px 5px 0px rgba(0,0,0,0.12)',
            padding: '5px',
            margin: '4px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100vh',
          }}
        >
          <div>
            <CircularProgress />
          </div>
        </div>
      </div>
    )

  if (error || err) return <div>failure {console.error(error || err)} </div>

  const foundUsers = new Map<string, Insight[]>()
  if (!data) return <div>No data</div>

  data.adminInsights
    .filter((a) => a.Domain === domain)
    .filter((a) =>
      alertStatus ? a.Status === 'Escalate' || a.Status === 'Error' || (a.Status === '' && a.Error !== '') : true
    )
    .forEach((insight: Insight) => {
      if (!foundUsers.has(insight.UserID)) {
        foundUsers.set(insight.UserID, [])
      }
      foundUsers.get(insight.UserID)?.push(insight)
    })

  const p = partnerData?.partners

  const tableData = Array.from(foundUsers, ([name, value]) => {
    const hasError = value.filter((v) => v.Error !== '')
    const uniqueErrors = new Set(hasError.filter((a) => a.Error !== '').map((v) => v.Error.substring(39))).size
    const uniqueBills = new Set(value.map((v) => v.BillHash)).size
    const firstUploadDate = new Date(
      value.sort((a, b) => new Date(a.GeneratedAt).getTime() - new Date(b.GeneratedAt).getTime())[0].GeneratedAt
    ).toLocaleString()
    const lastUploadDate = new Date(
      value.sort((a, b) => new Date(b.GeneratedAt).getTime() - new Date(a.GeneratedAt).getTime())[0].GeneratedAt
    ).toLocaleString()
    const badStatus = Boolean(
      value.filter((v) => v.Status === 'Escalate' || v.Status === 'Error' || (v.Status === '' && v.Error !== '')).length
    )
    const current =
      value[0].Error !== ''
        ? 'Error'
        : value[0].Status === '' || value[0].Status === 'Complete'
        ? 'OK'
        : value[0].Status
    const provider = value.length > 0 && value[0].Summary?.ProviderName ? value[0].Summary.ProviderName : 'N/A'
    return {
      errorUploads: hasError.length,
      name: name,
      email: value[0].UserEmail,
      totalUploads: value.length,
      uniqueErrors,
      uniqueBills,
      provider,
      lastUploadDate,
      firstUploadDate,
      insights: value,
      badStatus,
      current,
    }
  })

  return (
    <div style={{ position: 'relative' }}>
      <h1
        style={{ display: 'inline-block', verticalAlign: 'sub', marginLeft: '12px' }}
        className={CommonStyles.MainHeaderClass}
      >
        Energy Insight Issues
      </h1>
      <div
        style={{
          position: 'absolute',
          top: '50px',
          right: '450px',
          padding: '5px 10px',
          zIndex: 1000,
          flexFlow: 'flex-wrap',
          display: 'flex',
          justifyContent: 'space-between',
          gap: '16px',
        }}
      >
        <Box sx={{ width: 170 }}>
          <FormControl fullWidth>
            <InputLabel id="partner-id">PartnerID</InputLabel>
            <Select
              label="PartnerID"
              labelId="partner-id"
              value={partnerID}
              onChange={(e) => {
                setPartnerIDCache(e.target.value as string)
              }}
              style={{ fontSize: '22px', padding: '5px 2px' }}
            >
              {p.map((p: Partner) => (
                <MenuItem style={{ fontSize: '22px' }} key={p.ID} value={p.ID}>
                  {p.Name.toLocaleUpperCase()}
                </MenuItem>
              ))}
              <MenuItem style={{ fontSize: '22px' }} key={p.ID} value="superadmin">
                Super Admin
              </MenuItem>
            </Select>
          </FormControl>
        </Box>
        <Box sx={{ width: 200 }}>
          <FormControl fullWidth>
            <InputLabel id="domain">Domain</InputLabel>
            <Select
              label="PartnerID"
              labelId="Domain"
              value={domain}
              onChange={(e) => {
                setDomainCache(e.target.value as string)
              }}
              style={{ fontSize: '22px', padding: '5px 2px' }}
            >
              <MenuItem style={{ fontSize: '22px' }} key="energy" value="energy">
                Energy
              </MenuItem>
              <MenuItem style={{ fontSize: '22px' }} key="solar" value="solar">
                Solar
              </MenuItem>
              <MenuItem style={{ fontSize: '22px' }} key="energy-usage" value="energy-usage">
                Energy Usage
              </MenuItem>
            </Select>
          </FormControl>
        </Box>
        <Box
          sx={{
            width: 260,
            display: 'flex',
            alignItems: 'center',
            padding: '2px 10px',
          }}
        >
          <p style={{ color: '#333' }}>SHOW ALL</p>
          <Switch checked={alertStatus} onChange={() => setAlertStatusCache(!alertStatus)} />
          <p style={{ color: '#333' }}>OPS ALERT</p>
        </Box>
      </div>
      <div>
        <MaterialTable
          icons={tableIcons as Icons}
          columns={[
            {
              title: 'UserID',
              field: 'name',
              render: (rowData) => <a href={`/users/${rowData.name}`}>{rowData.name}</a>,
            },
            { title: 'Email', field: 'email' },
            { title: 'Provider', field: 'provider' },
            // { title: 'First Upload Date', field: 'firstUploadDate'},
            { title: 'Last Upload Date', field: 'lastUploadDate' },
            // { title: 'Total Uploads', field: 'totalUploads'},
            // { title: 'Failed Uploads', field: 'errorUploads'},
            // { title: 'Unique Errors', field: 'uniqueErrors'},
            // { title: 'Unique Bills', field: 'uniqueBills'},
            { title: 'User Status', field: 'current' },
            //{ title: 'Alert Status', field: 'badStatus', defaultFilter: ["true"], lookup: { true: 'true', false: 'false' },},
          ]}
          data={tableData}
          style={{
            paddingTop: '16px',
          }}
          options={{
            showTitle: false,
            sorting: true,
            filtering: true,
            search: true,
            pageSize: 50,
          }}
          detailPanel={(rowData) => {
            return <InsightDetails InsightDetails={rowData} refetch={refetch} />
          }}
        />
      </div>
    </div>
  )
}

export default Insights
